import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';

/** Enotna kartica tedna: cvenkotočke, odstotek in koliko manjka do kačinga. */
export function WeekScoreCard({
  memberId
}: {
  memberId?: string;
}) {
  const {
    viewer,
    isAdmin,
    weekFor,
    family
  } = useAppState();
  const {
    setTab,
    openSub
  } = useUi();
  const id = memberId ?? viewer.id;
  const week = weekFor(id);
  const needed = Math.max(0, Math.ceil(week.threshold * week.possible / 100) - week.earned);
  const child = !isAdmin;
  const message = week.excusedWeek ? 'Oproščen teden – žepnina ostane.' : week.reached ? child ? `KAČING! ${family.rules.allowanceAmount} ${family.rules.currency} je tvojih.` : 'Tedenski cilj dosežen.' : child ? `Še ${needed} do kačinga` : `Še ${needed} do cilja`;
  return <button type="button" onClick={() => isAdmin ? openSub({
    kind: 'progress'
  }) : setTab('napredek')} className={`block w-full rounded-3xl p-4 text-left transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent ${week.reached ? 'bg-done-soft hover:bg-[#cdebd7]' : 'border-[1.5px] border-line bg-surface shadow-card hover:bg-[#FFFCF6]'}`} data-id="element-1234" data-mp="223qmzz9anpth">
      <span className="flex items-baseline justify-between gap-3" data-id="element-1235" data-mp="33c5optdyvdee">
        <span className="text-xs font-extrabold text-muted" data-id="element-1236" data-mp="388e51a3whcn5">Ta teden</span>
        <ChevronRightIcon className="h-4 w-4 self-center text-muted" aria-hidden="true" data-id="element-1237" data-mp="3c9zl14bqe71k" />
      </span>
      <span className="mt-1 flex items-baseline gap-2" data-id="element-1238" data-mp="3h9kmbledirhg">
        <span className="font-display text-3xl tabular-nums leading-none" data-id="element-1239" data-mp="3h8161uspwgfo">
          {week.earned}
          <span className="text-lg text-muted" data-id="element-1240" data-mp="3m6krlu3efq7i"> / {week.possible}</span>
        </span>
        <span className="text-sm font-bold text-muted" data-id="element-1241" data-mp="1mxxij9di7gox">cvenkotočk</span>
        <span className={`ml-auto font-display text-2xl tabular-nums ${week.reached ? 'text-done-ink' : 'text-accent-ink'}`} data-id="element-1242" data-mp="1rvp8vyyi2ur0">{week.pct} %</span>
      </span>
      <span className="relative mt-3 block h-3 rounded-full bg-line" aria-hidden="true" data-id="element-1243" data-mp="1fswawu41im6o">
        <span className={`block h-full rounded-full ${week.reached ? 'bg-done' : 'bg-accent'}`} style={{
        width: `${week.pct}%`,
        transition: 'width 260ms cubic-bezier(0.23, 1, 0.32, 1)'
      }} data-id="element-1244" data-mp="1tse7hvnkv3ql" />
        <span className="absolute -top-1 h-5 w-1 rounded-full bg-ink" style={{
        left: `${week.threshold}%`
      }} data-id="element-1245" data-mp="22skecyort5gs" />
      </span>
      <span className={`mt-2 block text-sm font-extrabold ${week.reached ? 'text-done-ink' : 'text-ink'}`} data-id="element-1246" data-mp="1yqfqyhox152l">{message}</span>
      <span className="sr-only" data-id="element-1247" data-mp="2ci3zkazyhbet">Kačing pri {week.threshold} %.</span>
    </button>;
}